import React from "react";

function AgeIcon({ color = "#ffff" }: LevelIconPropsType) {
  return (
    <svg
    id="age"
    className="w-[15.34px] lg:w-[1.375rem] h-auto"
    xmlns="http://www.w3.org/2000/svg"
    width="31.826"
    height="41.5"
    viewBox="0 0 31.826 41.5"
  >
    <path
      id="FILL"
      d="M-20455.518-4872.611h30.326v-8.838c0-4.664-2.59-6.176-6.525-7.185a41.368,41.368,0,0,0-8.834-.561,47.072,47.072,0,0,0-8.434.561c-6.242,1.29-6.533,5.815-6.533,7.568Z"
      transform="translate(20456.268 4913.361)"
      fill={color}
    />
    <path
      id="FILL-2"
      data-name="FILL"
      d="M-20447.635-4890.473s-1.623-6.1,1.168-8.515a6.466,6.466,0,0,1,8.746,0c2.5,2.128,1.264,8.515,1.264,8.515Z"
      transform="translate(20457.924 4914.57)"
      fill={color}
    />
    <path
      id="FILL-3"
      data-name="FILL"
      d="M-20442.609-4910.734s-3.287,5.717-3.287,7.579a3.264,3.264,0,0,0,3.287,3.315,3.167,3.167,0,0,0,3.285-3.315C-20439.324-4905.182-20442.609-4910.734-20442.609-4910.734Z"
      transform="translate(20458.525 4911.484)"
      fill={color}
    />
    <path
      id="STROKE"
      d="M-20425.191-4871.861h-30.326a.75.75,0,0,1-.75-.75v-8.455c0-5.645,3.879-7.63,7.131-8.3l.018,0a32.963,32.963,0,0,1,6.256-.524c.705-.01,1.434-.02,2.287-.048h.025a41.922,41.922,0,0,1,8.99.577l.029.007a10.89,10.89,0,0,1,5.07,2.405,7.186,7.186,0,0,1,2.02,5.506v8.838A.75.75,0,0,1-20425.191-4871.861Zm-29.576-1.5h28.826v-8.088c0-4.139-2.09-5.463-5.945-6.454a40.945,40.945,0,0,0-8.652-.541c-.863.028-1.629.039-2.3.048a31.363,31.363,0,0,0-6,.5c-3.932.815-5.926,3.114-5.926,6.832Z"
      transform="translate(20456.268 4913.361)"
      fill="#220859"
    />
    <path
      id="STROKE-2"
      data-name="STROKE"
      d="M-20431.687-4879.291a4.117,4.117,0,0,1-2.861-1.11,2.058,2.058,0,0,0-1.426-.643,1.656,1.656,0,0,0-1.262.6,3.815,3.815,0,0,1-2.859,1.152,4.478,4.478,0,0,1-2.939-1.062,2.577,2.577,0,0,0-1.73-.69,3.5,3.5,0,0,0-2.1.813,4.229,4.229,0,0,1-2.459.939,4.018,4.018,0,0,1-2.68-1.27,2.441,2.441,0,0,0-1.258-.758q-.179-.009-.346-.009a4.991,4.991,0,0,0-1.629.231l0,0-.559-1.392a6.161,6.161,0,0,1,2.176-.338q.205,0,.428.011a3.615,3.615,0,0,1,2.168,1.124,2.675,2.675,0,0,0,1.7.9,2.879,2.879,0,0,0,1.621-.683,4.95,4.95,0,0,1,2.941-1.07,4,4,0,0,1,2.619.982,3,3,0,0,0,2.051.771,2.347,2.347,0,0,0,1.859-.769,3.094,3.094,0,0,1,2.262-.984,3.508,3.508,0,0,1,2.365.974,2.664,2.664,0,0,0,1.922.779,2.612,2.612,0,0,0,1.918-.913,3.419,3.419,0,0,1,2.377-1.12c.066,0,.135,0,.205.007a14.5,14.5,0,0,1,1.814.2.99.99,0,0,1,.824.584.75.75,0,0,1-.471.951.747.747,0,0,1-.6-.055,10.945,10.945,0,0,0-1.662-.181c-.037,0-.074,0-.109,0-.525,0-.844.261-1.375.737A4.044,4.044,0,0,1-20431.687-4879.291Z"
      transform="translate(20456.266 4915.185)"
      fill="#220859"
    />
    <path
      id="STROKE-3"
      data-name="STROKE"
      d="M-20436.457-4889.723h-11.178a.75.75,0,0,1-.725-.557c-.072-.268-1.709-6.587,1.4-9.275a7.362,7.362,0,0,1,4.832-1.886,7.62,7.62,0,0,1,4.891,1.882c1.213,1.032,1.83,2.924,1.834,5.626a20.659,20.659,0,0,1-.32,3.6A.75.75,0,0,1-20436.457-4889.723Zm-10.578-1.5h9.943c.287-1.981.475-5.841-1.115-7.193a6.032,6.032,0,0,0-3.918-1.525,5.878,5.878,0,0,0-3.852,1.522c-1.219,1.052-1.418,3.066-1.371,4.57A16.1,16.1,0,0,0-20447.035-4891.223Z"
      transform="translate(20457.924 4914.57)"
      fill="#220859"
    />
    <path
      id="STROKE-4"
      data-name="STROKE"
      d="M-20443.484-4900.494a.75.75,0,0,1-.75-.75v-1.538a.75.75,0,0,1,.75-.75.75.75,0,0,1,.75.75v1.538A.75.75,0,0,1-20443.484-4900.494Z"
      transform="translate(20459.398 4914.489)"
      fill="#220859"
    />
    <path
      id="STROKE-5"
      data-name="STROKE"
      d="M-20442.609-4911.484a.747.747,0,0,1,.645.368c.348.586,3.391,5.792,3.391,7.961a3.917,3.917,0,0,1-4.035,4.065,4.008,4.008,0,0,1-4.037-4.065c0-.331,0-1.339,1.721-4.82.824-1.664,1.633-3.073,1.666-3.133a.75.75,0,0,1,.646-.376Zm0,10.894a2.415,2.415,0,0,0,2.535-2.565c0-1.108-1.361-3.937-2.527-6.051-1.17,2.165-2.545,5.037-2.545,6.051A2.524,2.524,0,0,0-20442.609-4900.59Z"
      transform="translate(20458.525 4911.484)"
      fill="#220859"
    />
  </svg>
  );
}

export default AgeIcon;
type LevelIconPropsType = {
  color?: string;
};
